/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import StripeApiKey from './StripeApiKey'

/**
 * The InlineResponse20022 model module.
 * @module model/InlineResponse20022
 * @version 1.0.0
 */
export default class InlineResponse20022 {
  /**
   * Constructs a new <code>InlineResponse20022</code>.
   * @alias module:model/InlineResponse20022
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20022</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20022} obj Optional instance to populate.
   * @return {module:model/InlineResponse20022} The populated <code>InlineResponse20022</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20022()

      if (data.hasOwnProperty('stripe_api_key')) {
        obj['stripe_api_key'] = StripeApiKey.constructFromObject(data['stripe_api_key'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/StripeApiKey} stripe_api_key
   */
  stripe_api_key = undefined
}
